import { getEnv } from '@config';

const { country } = getEnv();

export const REGIONS = {
  cl: {
    defaultDocumentType: 'RUT',
    regionPhoneCode: '56',
    currency: 'CLP',
    currencySymbol: '$',
    decimalCount: 0,
    decimalSeparator: ',',
    thousandSeparator: '.',
    daysToRefund: 150,
    daysToRefundOnus: 150,
    onboarding: false,
    dateFormat: 'dd/MM/yyyy',
    locale: 'es-CL',
  },
  pe: {
    defaultDocumentType: 'RUC',
    regionPhoneCode: '51',
    currency: 'PEN',
    currencySymbol: 'S/',
    decimalCount: 2,
    decimalSeparator: '.',
    thousandSeparator: ',',
    daysToRefund: 180,
    daysToRefundOnus: 180,
    onboarding: false,
    dateFormat: 'dd/MM/yyyy',
    locale: 'es-PE',
  },
  co: {
    defaultDocumentType: 'DNI',
    regionPhoneCode: '57',
    currency: 'COP',
    currencySymbol: '$',
    decimalCount: 0,
    decimalSeparator: ',',
    thousandSeparator: '.',
    daysToRefund: 180,
    daysToRefundOnus: 180,
    onboarding: false,
    dateFormat: 'dd/MM/yyyy',
    locale: 'es-CO',
  },
};

export const {
  regionPhoneCode,
  defaultDocumentType,
  currencySymbol,
  decimalSeparator,
  thousandSeparator,
} = REGIONS[country];
export const isCountryPeru = country === 'pe';
export const isCountryChile = country === 'cl';
export const isCountryColombia = country === 'co';
export const isCountryChileOrColombia = ['cl', 'co'].includes(country);
export const isCountryPeruOrColombia = ['pe', 'co'].includes(country);
export const isCountryChileOrPeru = ['pe', 'cl'].includes(country);
